export const downloadFile = (res: Blob, fileName: string) => {
  const a = document.createElement("a");
  const href = URL.createObjectURL(res);
  a.href = href;
  a.setAttribute("download", fileName);
  a.setAttribute("target", "_blank");
  a.click();
  URL.revokeObjectURL(href);
};
